/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeliveryOption = 'TOTAL_DELIVERY' | 'PARTIAL_DELIVERY';

export const DeliveryOption = {
    TOTAL_DELIVERY: 'TOTAL_DELIVERY' as DeliveryOption,
    PARTIAL_DELIVERY: 'PARTIAL_DELIVERY' as DeliveryOption
};

